import {Component, OnInit} from '@angular/core';
import {Questions } from '../classes/question';
import {BroadcastEventService} from "../shared/services/broadcast.event.service";

@Component({
  selector: 'old-central-pannel',
  templateUrl: 'old-central-pannel.component.html',
  styleUrls: ['old-central-pannel.component.css']
})


export class OldCentralPannelComponent implements OnInit{


  isPreviousDisabled : boolean = true;
  isNextDisabled : boolean = true;

  whichScreenToShow : string = "selectQuestionType";
  questionTypeForHeading : string = "";
  maxDefault : number = 99999999;
  areYouSure : string = "Are you sure ?";
  changesWillBeDiscarded : string = "All changes will be discarded.";
  optionsAlertMessage : string = "Option in both languages need to be added.";

  tempPrimaryOption : string = "";
  tempSecondaryOption : string = "";



  newQuestion : Questions = new Questions;
  forOptionsDrag  : Array<ForOptionsDrag> = [];
  previousDialogBox : string = "";
  userEnteringOptions : boolean = false;
  shouldIShowOptionsAlert : boolean = false;


  questions : Questions[] = [];

  constructor(private broadcastEventService : BroadcastEventService){
    this.broadcastEventService.setQuestions(this.questions);
    this.newQuestion = new Questions;
  }

  ngOnInit(){

  }



  questionTypeSelected(type : string , calledFrom : string){


    switch (type){
      case 'Subjective':{
      }
      case 'NaturalNumMAX':{
      }
      case 'WholeNumMAX':{
      }
      case 'DecimalMax':{
      }
      case 'Map':{
      }
      case 'Picture Input':{

      }
      case 'MobileNumMAX10':{


        this.questionTypeForHeading = type;
        this.whichScreenToShow = 'subjectiveType';
        this.isPreviousDisabled = false;
        this.isNextDisabled = false;
        this.newQuestion.Min_Char = 1;



        //ToDo : Just to test will remove after adding repeat questions
        this.newQuestion.Repeat_Dependence = null;
        //ToDo : Just to test will remove after adding dependent questions
        this.newQuestion.Opt_Dep = [1];
        this.newQuestion.Opt_Dep.pop();
        this.newQuestion.Qn_Deps = [1];
        this.newQuestion.Qn_Deps.pop();
        //ToDo : Just to test will remove after adding age param to questions
        this.newQuestion.Age_Range = [1];
        this.newQuestion.Age_Range.pop();

        //ToDo : Replace it with more complex theory after adding repeater and dependent questions


        if(calledFrom === 'new') {
          this.newQuestion.Qn_Type = type;
          this.newQuestion.Is_Mandt = true;
          this.newQuestion.Qn_Num = this.questions.length + 1;
          this.newQuestion.Qn_In = "" + (this.questions.length + 1 );
          this.newQuestion.Max_Char = this.maxDefault;

          if ((this.newQuestion.Qn_Type.charAt(0) === 'N' || this.newQuestion.Qn_Type.charAt(0) === 'W' || this.newQuestion.Qn_Type.charAt(0) === 'D')) {
            this.newQuestion.Qn_Type = this.newQuestion.Qn_Type + this.maxDefault;
          }
          this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
          this.broadcastEventService.setQuestions(this.questions);
        }
        break;
      }
      case 'Radio':{
      }
      case 'Checkbox':{
      }
      case 'Selected Dropdown':{

        this.questionTypeForHeading = type;
        this.whichScreenToShow = 'radioType';
        this.isPreviousDisabled = false;
        this.isNextDisabled = false;
        this.newQuestion.Min_Char = 1;
        this.newQuestion.Max_Char = this.maxDefault;

        //ToDo : Just to test will remove after adding repeat questions
        this.newQuestion.Repeat_Dependence = null;
        //ToDo : Just to test will remove after adding dependent questions
        this.newQuestion.Opt_Dep = [1];
        this.newQuestion.Opt_Dep.pop();
        this.newQuestion.Qn_Deps = [1];
        this.newQuestion.Qn_Deps.pop();
        //ToDo : Just to test will remove after adding age param to questions
        this.newQuestion.Age_Range = [1];
        this.newQuestion.Age_Range.pop();

        //ToDo : Replace it with more complex theory after adding repeater and dependent questions
        if(calledFrom === 'new') {
          this.newQuestion.Qn_Type = type;
          this.newQuestion.Is_Mandt = true;

          this.newQuestion.Qn_Num = this.questions.length + 1;
          this.newQuestion.Qn_In = "" + (this.questions.length + 1 );
          this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
          this.broadcastEventService.setQuestions(this.questions);
        }
        break;

      }
      case 'Button':{
        this.questionTypeForHeading = 'Cascading Drop Down';
        this.whichScreenToShow = 'cascadingDropdownType';
        this.isPreviousDisabled = false;
        this.isNextDisabled = false;
        this.newQuestion.Min_Char = 1;
        this.newQuestion.Max_Char = this.maxDefault;
        //ToDo : Just to test will remove after adding repeat questions
        this.newQuestion.Repeat_Dependence = null;
        //ToDo : Just to test will remove after adding dependent questions
        this.newQuestion.Opt_Dep = [1];
        this.newQuestion.Opt_Dep.pop();
        this.newQuestion.Qn_Deps = [1];
        this.newQuestion.Qn_Deps.pop();
        //ToDo : Just to test will remove after adding age param to questions
        this.newQuestion.Age_Range = [1];
        this.newQuestion.Age_Range.pop();

        //ToDo : Replace it with more complex theory after adding repeater and dependent questions
        if(calledFrom === 'new') {
          this.newQuestion.Qn_Type = type;
          this.newQuestion.Is_Mandt = true;

          this.newQuestion.Qn_Num = this.questions.length + 1;
          this.newQuestion.Qn_In = "" + (this.questions.length + 1 );
          this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
          this.broadcastEventService.setQuestions(this.questions);
        }
        break;

      }
      case 'Calendar':{

        this.questionTypeForHeading = 'Calendar';
        this.whichScreenToShow = 'calendarType';
        this.isPreviousDisabled = false;
        this.isNextDisabled = false;
        this.newQuestion.Min_Char = 1;
        this.newQuestion.Max_Char = this.maxDefault;
        //ToDo : Just to test will remove after adding repeat questions
        this.newQuestion.Repeat_Dependence = null;
        //ToDo : Just to test will remove after adding dependent questions
        this.newQuestion.Opt_Dep = [1];
        this.newQuestion.Opt_Dep.pop();
        this.newQuestion.Qn_Deps = [1];
        this.newQuestion.Qn_Deps.pop();
        //ToDo : Just to test will remove after adding age param to questions
        this.newQuestion.Age_Range = [1];
        this.newQuestion.Age_Range.pop();

        //ToDo : Replace it with more complex theory after adding repeater and dependent questions
        if(calledFrom === 'new') {
          this.newQuestion.Qn_Type = type;
          this.newQuestion.Is_Mandt = true;
          this.newQuestion.Qn_Num = this.questions.length + 1;
          this.newQuestion.Qn_In = "" + (this.questions.length + 1 );
          this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
          this.broadcastEventService.setQuestions(this.questions);
        }
        break;

      }
    }

  }


  isRequiredChanged(require : boolean){
    this.newQuestion.Is_Mandt = require;
    this.questions.pop();
    this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
    this.broadcastEventService.setQuestions(this.questions);
  }


  primaryQuestionEntered(question : string){

    this.newQuestion.Qn = question;
    this.questions.pop();
    this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
    this.broadcastEventService.setQuestions(this.questions);
  }


  secondaryQuestionEntered(question : string){
    this.newQuestion.S_Qn = question;
    this.questions.pop();
    this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
    this.broadcastEventService.setQuestions(this.questions);
  }


  maxEntered(max : string){

    if(this.newQuestion.Qn_Type === 'Subjective'){
      if(max && max.length > 0)
        this.newQuestion.Max_Char = parseInt(max);
      else
        this.newQuestion.Max_Char = this.maxDefault;
    }else if(this.newQuestion.Qn_Type.charAt(0) === 'N'){
      if(max && max.length > 0)
        this.newQuestion.Qn_Type = "NaturalNumMax" + max;
      else
        this.newQuestion.Qn_Type = "NaturalNumMax" + this.maxDefault;
    }else if(this.newQuestion.Qn_Type.charAt(0) === 'W'){
      if(max && max.length > 0)
        this.newQuestion.Qn_Type = "WholeNumMax" + max;
      else
        this.newQuestion.Qn_Type = "WholeNumMax" + this.maxDefault;
    }else if(this.newQuestion.Qn_Type.charAt(0) === 'D'){
      if(max && max.length > 0)
        this.newQuestion.Qn_Type = "DecimalMax" + max;
      else
        this.newQuestion.Qn_Type = "DecimalMax" + this.maxDefault;
    }

    this.questions.pop();
    this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
    this.broadcastEventService.setQuestions(this.questions);
  }


  addOptionsClicked(){

    this.userEnteringOptions = true;
  }

  typeOfCalendar(type : string){
    this.newQuestion.Qn_Type = type;
    this.questions.pop();
    this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
    this.broadcastEventService.setQuestions(this.questions);
  }

  dismissAlert(){
    this.shouldIShowOptionsAlert = false;
  }

  primaryOptionAdded(option: string){
    if(option && option.length > 0) {
      this.tempPrimaryOption = option;
    }
    else
      this.tempPrimaryOption = "";
  }


  secondaryOptionAdded(option : string){
    if(option && option.length > 0) {
      this.tempSecondaryOption = option;
    }
    else
      this.tempSecondaryOption = "";
  }


  addOption(primaryOption : any , secondaryOption : any){
    if(this.tempPrimaryOption.length > 0 && this.tempSecondaryOption.length > 0){
      if(!this.newQuestion.Opt_Name){
        this.newQuestion.Opt_Name = [""];
        this.newQuestion.Opt_Name.pop();
      }
      if(!this.newQuestion.S_Opt_Name){
        this.newQuestion.S_Opt_Name = [""];
        this.newQuestion.S_Opt_Name.pop();
      }
      primaryOption.value = "";
      secondaryOption.value = "";
      this.newQuestion.Opt_Name.push(this.tempPrimaryOption);
      this.newQuestion.S_Opt_Name.push(this.tempSecondaryOption);
      this.forOptionsDrag.push({
        primaryOption : this.tempPrimaryOption,
        secondaryOption : this.tempSecondaryOption
      });
      this.tempPrimaryOption = "";
      this.tempSecondaryOption = "";
      this.shouldIShowOptionsAlert = false;

    }else{
      this.shouldIShowOptionsAlert = true;
    }
    this.questions.pop();
    this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
    this.broadcastEventService.setQuestions(this.questions);
  }


  removeOption(index : number){
    this.forOptionsDrag.splice(index,1);
    this.newQuestion.Opt_Name.splice(index,1);
    this.newQuestion.S_Opt_Name.splice(index,1);
    this.questions.pop();
    this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
    this.broadcastEventService.setQuestions(this.questions);
  }


  optionsChangedFromDrag(){


    for(let i = 0 ; i < this.forOptionsDrag.length; i = i+1 ){
      this.newQuestion.Opt_Name[i] = this.forOptionsDrag[i].primaryOption;
      this.newQuestion.S_Opt_Name[i] = this.forOptionsDrag[i].secondaryOption;
    }
    this.questions.pop();
    this.questions.push(JSON.parse(JSON.stringify(this.newQuestion)));
    this.broadcastEventService.setQuestions(this.questions);
  }

  clickedSave(){
    this.previousDialogBox = "";
    this.isNextDisabled = true;
    this.isPreviousDisabled = true;
    this.userEnteringOptions = false;
    this.whichScreenToShow = 'selectQuestionType';
    this.forOptionsDrag = [];
    this.newQuestion = new Questions;
  }


  clickedPrevious(){


    if( (this.newQuestion.Qn && this.newQuestion.Qn.length > 0) || (this.newQuestion.S_Qn && this.newQuestion.S_Qn.length > 0) || (this.newQuestion.Is_Mandt === false)) {
      this.previousDialogBox = ".previousDialogBox";
    }
    else if(this.newQuestion.Max_Char !== this.maxDefault){
      this.previousDialogBox = ".previousDialogBox";
    }
    else if(this.newQuestion.Qn_Type.charAt(0)==='N' || this.newQuestion.Qn_Type.charAt(0)==='W' || this.newQuestion.Qn_Type.charAt(0)==='D'){
      if(this.newQuestion.Qn_Type.substring(this.newQuestion.Qn_Type.length - 8 ,this.newQuestion.Qn_Type.length) !== this.maxDefault.toString()){
        this.previousDialogBox = ".previousDialogBox";
      }else {
        this.previousDialogBox = "";
        this.isNextDisabled = true;
        this.isPreviousDisabled = true;
        this.userEnteringOptions = false;
        this.whichScreenToShow = 'selectQuestionType';
        this.questions.pop();
        this.broadcastEventService.setQuestions(this.questions);
        this.forOptionsDrag = [];
        this.newQuestion = new Questions;
      }
    }else if(this.newQuestion.Qn_Type ==='Radio' || this.newQuestion.Qn_Type === 'Checkbox' || this.newQuestion.Qn_Type === 'Selected Dropdown'){
      if( (this.newQuestion.Opt_Name && this.newQuestion.Opt_Name.length >0 ) || (this.newQuestion.S_Opt_Name && this.newQuestion.S_Opt_Name.length > 0 )|| this.tempPrimaryOption.length > 0 || this.tempSecondaryOption.length > 0){
        this.previousDialogBox = ".previousDialogBox";
      }else{
        this.previousDialogBox = "";
        this.isNextDisabled = true;
        this.isPreviousDisabled = true;
        this.userEnteringOptions = false;
        this.whichScreenToShow = 'selectQuestionType';
        this.questions.pop();
        this.broadcastEventService.setQuestions(this.questions);
        this.forOptionsDrag = [];
        this.newQuestion = new Questions;
      }
    }
    else{
      this.previousDialogBox = "";
      this.isNextDisabled = true;
      this.isPreviousDisabled = true;
      this.userEnteringOptions = false;
      this.whichScreenToShow = 'selectQuestionType';
      this.questions.pop();
      this.broadcastEventService.setQuestions(this.questions);
      this.forOptionsDrag = [];
      this.newQuestion = new Questions;
    }
  }


  previousUserClickedYes(){
    this.newQuestion = new Questions;
    this.isNextDisabled = true;
    this.isPreviousDisabled = true;
    this.userEnteringOptions = false;
    this.tempPrimaryOption = "";
    this.tempSecondaryOption = "";
    this.forOptionsDrag = [];
    this.whichScreenToShow = 'selectQuestionType';
    this.questions.pop();
    this.broadcastEventService.setQuestions(this.questions);
    this.forOptionsDrag = [];
    this.newQuestion = new Questions;
  }


  previousUserClickedNo(){
    this.previousDialogBox = "";
  }



  TabChanged(type : string){

    switch (type){
      case 'new':{
        // console.log('tab changed to new');
        if(!this.newQuestion.Qn_Type || this.newQuestion.Qn_Type === '') {
          this.whichScreenToShow = 'selectQuestionType';
        }else{
          if(this.newQuestion.Qn_Type.charAt(0) === 'N'){
            this.questionTypeSelected('NaturalNumMAX','dep');
          }else if(this.newQuestion.Qn_Type.charAt(0) === 'W'){
            this.questionTypeSelected('WholeNumMAX','dep');
          }else if(this.newQuestion.Qn_Type.charAt(0) === 'D'){
            this.questionTypeSelected('DecimalMax','dep');
          }else if(this.newQuestion.Qn_Type.charAt(0) === 'C'){
            this.questionTypeSelected('Calendar','dep');
          }else{
            this.questionTypeSelected(this.newQuestion.Qn_Type,'dep');
          }
        }
        break;
      }
      case 'dep':{
        console.log(this.newQuestion.Qn_Type);
        this.whichScreenToShow = 'dependent';
        break;
      }
      case 'age':{
        this.whichScreenToShow = 'ageDependent';
        break;
      }
    }

  }

}


class ForOptionsDrag {
  primaryOption : string;
  secondaryOption : string;
}
































// //ToDo : For testing drag and drop
// question : Question = new Question("");
// selected : string;
// tabs : string[] = ["home", "profile", "settings","messages"];
//
// // //For drag and drop
// // //ToDo : logic will become more complex later
// // addQuestion($event : any){
// //   this.question = $event.dragData;
// // }

// //ToDo: Only for testing drag and drop
// //Will use general Questions class later
// class Question{
//   constructor(
//     public question : string
//   ){}
// }



// WEBPACK FOOTER //
// ./src/app/oldCentralPannel/old-central-pannel.component.ts